import React from "react";
import { FiEdit3, FiChevronUp, FiChevronDown } from "react-icons/fi";
import { FaUser } from "react-icons/fa";
import { TbSearch } from "react-icons/tb";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { FaClock } from "react-icons/fa";
import { PiNoteFill } from "react-icons/pi";
import { useHistory } from "react-router-dom";
import { RateTypeShippingEnum } from "../../../../enums/RateTypeShippingEnum";
import formatCep from "../../../../utils/FormatCep";
import { momentBDays } from "../../../../utils/MomentBDay";
import styles from "./styles.module.scss";
import ShippingStagesEnum from "../../../../enums/ShippingStagesEnum";
import { StyledTooltip } from "../../components/Tooltip";
import { addBusinessDaysIgnoreHolidays } from "../../../../utils/calculateBusinessDay";
import { formatOwnCollectStartAndEnd } from "../../../../utils/OwnCollectTime";
import { OwnCollectFrequencyTitleEnum } from "../../../../enums/OwnCollectFrequency";

export function CartSimpleCardShipping({
  cardPackage,
  onExpand,
  isExpand,
  widthWindows,
  isCancelled,
  edit = true,
  expand = true,
}) {
  const history = useHistory();

  const addressInfoHandled = address => {
    let finalAddress = address?.street;

    if (!!address?.number) {
      finalAddress += `, ${address?.number}`;
    }

    if (!!address?.complement) {
      finalAddress += `, ${address?.complement}`;
    }

    if (!!address?.district) {
      finalAddress += `, ${address?.district}`;
    }

    return finalAddress;
  };

  const handleStatusColor = status => {
    const color = {
      [ShippingStagesEnum.ENTREGA_REALIZADA.id]: "#409E6A",
      [ShippingStagesEnum.OBJETO_EM_TRANSITO.id]: "#F5CB2B",
      [ShippingStagesEnum.OBJETO_SAIU_PARA_ENTREGA.id]: "#F5CB2B",
      [ShippingStagesEnum.OBJETO_NAO_FOI_ENTREGUE.id]: "#CA1818"
    };

    return color[status];
  };

  const handleCardData = (data) => {
    if (!!data) {
      const isOwnCollect = !!data?.collectTimeStart || !!data?.collectTimeEnd || !!data?.collectFrequency

      return isOwnCollect
        ? {
          ...data,
          destination: data?.collectAddress,
          isOwnCollect: true
        }
        : {
          ...data,
          isShipping: true
        }
    }
  }

  const cardData = handleCardData(cardPackage)

  const clientName = cardData?.user?.userData[1]?.Value?.split(" ", 2).join(
    " "
  );

  return (
    <>
      <div
        className={`${styles.cardWrapper}
      ${cardData.blocked && styles.blockedCard} ${isCancelled &&
          styles.cancelledCard}`}
      >
        {widthWindows > 1024 ? (
          <div
            className={`${styles.cardHeader}
            ${cardData.blocked && styles.blockedShipping}`}
          >
            <div
              style={{
                backgroundColor: handleStatusColor(cardData.idShippingStatus)
              }}
              className={styles.dotStatus}
            />

            <div className={styles.content}>
              <div className={`${styles.groupInfo} ${styles.requests}`}>
                <div>
                  <PiNoteFill color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>
                    {cardData?.isOwnCollect ? "COLETA" : "PEDIDO"}:
                  </strong>
                </div>
                {cardData?.orderNumber !== null &&
                  cardData?.orderNumber > 0 ? (
                  <span className={styles.shippingInfo}>
                    {cardData?.orderObject?.orderCode || cardData?.orderNumber}
                  </span>
                ) : cardData?.isOwnCollect ?
                  <span className={styles.shippingInfo}>
                    {cardData?.id}
                  </span> : "--"}
              </div>

              <div className={styles.usersGroupInfo}>
                <div className={`${styles.groupInfo} ${styles.clients}`}>
                  <div>
                    <FaUser color="#409E6A" size={18} />
                    <strong className={styles.titleDescription}>
                      CLIENTE:
                    </strong>
                  </div>
                  {clientName ? (
                    <span className={styles.shippingInfo} title={clientName} >{clientName}</span>
                  ) : "--"}
                </div>
              </div>

              <div className={`${styles.groupInfo} ${styles.identification}`}>
                <TbSearch color="#409E6A" size={22} />
                <strong className={styles.titleDescription}>{cardData?.isOwnCollect ? "FREQUÊNCIA" : "IDENTIFICAÇÃO"}:</strong>
                {cardData?.sro !== null && !!cardData?.sro ? (
                  <a
                    href={`/detalhes-objeto/${cardData.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className={styles.shippingInfo} title={cardData.sro}>
                      <b>{cardData?.sro}</b>
                    </span>
                  </a>
                ) : cardData?.isOwnCollect ?
                  <span className={styles.shippingInfo} title={cardData.sro}>
                    <b>{OwnCollectFrequencyTitleEnum[cardData?.collectFrequency]?.toUpperCase() ?? "--"}</b>
                  </span> : "--"}
              </div>

              {cardData?.isOwnCollect
                ? <div className={`${styles.groupInfo} ${styles.value}`}>
                  <div>
                    <FaClock color="#409E6A" size={22} />
                    <strong className={styles.titleDescription}>HORÁRIO:</strong>
                  </div>
                  <span className={styles.shippingInfo}>
                    {formatOwnCollectStartAndEnd(cardData?.collectTimeStart, cardData?.collectTimeEnd) || "--"}
                  </span>
                </div>
                : <div className={`${styles.groupInfo} ${styles.value}`}>
                  <div>
                    <RiMoneyDollarCircleFill color="#409E6A" size={22} />
                    <strong className={styles.titleDescription}>VALOR:</strong>
                  </div>
                  <span className={styles.shippingInfo}>
                    {cardData?.price ? new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    }).format(cardData?.price) : "--"}
                  </span>
                </div>}

              {cardData?.isOwnCollect
                ? <strong className={styles.shippingTypeInfo}>
                  {`Coleta Própria`}
                </strong>
                : <strong className={styles.shippingTypeInfo}>
                  {`${cardData?.correios?.nome?.replace("Entrega", "")}
                  ${cardData?.isLogisticsReverse ? " (Reversa)" : ""}
                  ${isCancelled ? " (Cancelado)" : ""}
                  `}
                </strong>}
            </div>
            <div className={styles.actionButtonsContainer}>
              {expand &&
                (isExpand ? (
                  <div onClick={onExpand}>
                    <FiChevronUp />
                  </div>
                ) : (
                  <div onClick={onExpand}>
                    <FiChevronDown />
                  </div>
                ))}
            </div>
          </div>
        ) : (
          <div
            className={`${styles.cardHeaderMobile}
            ${cardData.blocked && styles.blockedShipping} ${isCancelled &&
              styles.cancelledCard}`}
          >
            <div className={styles.content}>
              {cardData?.orderNumber !== null && cardData?.orderNumber > 0 && cardData?.isShipping && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>PEDIDO:</strong>
                  <span className={styles.shippingInfo}>
                    {cardData?.orderObject?.orderCode || cardData?.orderNumber}
                  </span>
                </div>
              )}
              {cardData?.isOwnCollect && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>COLETA:</strong>
                  <span className={styles.shippingInfo}>
                    {cardData?.id}
                  </span>
                </div>
              )}
              {cardData?.sro !== null && !!cardData?.sro && cardData?.isShipping && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>IDENTIFICAÇÃO:</strong>
                  <span className={styles.shippingInfo}>{cardData?.sro}</span>
                </div>
              )}
              {cardData?.isOwnCollect && !!cardData?.collectFrequency && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>FREQUÊNCIA:</strong>
                  <span className={styles.shippingInfo}>{OwnCollectFrequencyTitleEnum[cardData?.collectFrequency]?.toUpperCase() ?? "--"}</span>
                </div>
              )}
              {cardData?.invoiceNumber !== null &&
                Number(cardData?.invoiceNumber) >= 1 &&
                !!cardData?.invoiceNumber && (
                  <div className={styles.groupInfo}>
                    <strong className={styles.titleDescription}>
                      NOTA FISCAL:
                    </strong>
                    <span className={styles.shippingInfo}>
                      {cardData?.invoiceNumber}
                    </span>
                  </div>
                )}
              <div className={styles.groupInfo}>
                <div className={styles.shippingTypeAndValue}>
                  <strong className={styles.titleDescription}>{cardData?.isOwnCollect ? "HORA" : "VALOR"}:</strong>
                  {cardData?.isOwnCollect
                    ? <span className={styles.shippingInfo}>
                      {formatOwnCollectStartAndEnd(cardData?.collectTimeStart, cardData?.collectTimeEnd) || "--"}
                    </span>
                    : <span className={styles.shippingInfo}>
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                      }).format(cardData?.price)}
                    </span>}

                  <strong className={styles.shippingType}>
                    {cardData?.isOwnCollect ? "Coleta Própria" : `${cardData?.correios?.nome?.replace("Entrega", "")}${isCancelled ? " (Cancelado)" : ""
                      }`}
                  </strong>
                </div>
              </div>

            </div>
            <div className={styles.actionButtonsContainer}>
              <div style={{ display: "flex", gap: "8px" }}>
                {expand &&
                  (isExpand ? (
                    <div onClick={onExpand}>
                      <FiChevronUp className={styles.iconOpenClose} />
                    </div>
                  ) : (
                    <div onClick={onExpand}>
                      <FiChevronDown className={styles.iconOpenClose} />
                    </div>
                  ))}
                {(cardData?.numeroPLP <= 1 ||
                  cardData?.numeroPLP === "null") && (
                    <StyledTooltip text="Editar" position="top" arrow>
                      <FiEdit3
                        className={styles.iconEdit}
                        onClick={() => {
                          if (!isCancelled) {
                            history.push(
                              `/nova-coleta/send-form?shipping=${cardData?.id}`
                            );
                          }
                        }}
                      />
                    </StyledTooltip>
                  )}
              </div>
            </div>
          </div>
        )}

        <div className={!isExpand ? styles.cardBodyHidden : styles.cardBody}>
          {cardData?.isShipping && <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>REMETENTE</h3>
            <div className={styles.collectInfo}>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Nome:</span>
                {cardData?.origin?.name}
              </p>
              <p>
                <span className={styles.highlighted}>CEP:</span>
                {formatCep(cardData?.origin?.zip)}
              </p>

              <p>
                <span className={styles.highlighted}>Endereço:</span>
                {addressInfoHandled({
                  street: cardData?.origin?.street,
                  number: cardData?.origin?.number,
                  complement: cardData?.origin?.complement,
                  district: cardData?.origin?.district
                })}
                - {`${cardData?.origin?.city}/${cardData?.origin?.state}`}
              </p>
            </div>
          </div>}

          <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>{cardData?.isOwnCollect ? "END. DE COLETA" : "DESTINATÁRIO"}</h3>
            <div className={styles.collectInfo}>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Nome:</span>
                {cardData?.destination?.name}
              </p>
              <p>
                <span className={styles.highlighted}>CEP:</span>
                {formatCep(cardData?.destination?.zip)}
              </p>

              <p>
                <span className={styles.highlighted}>Endereço:</span>
                {addressInfoHandled({
                  street: cardData?.destination?.street,
                  number: cardData?.destination?.number,
                  complement: cardData?.destination?.complement,
                  district: cardData?.destination?.district
                })}
                -{" "}
                {`${cardData?.destination?.city}/${cardData?.destination?.state}`}
              </p>
            </div>
          </div>

          {cardData?.isShipping && <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>PACOTE</h3>
            <div className={styles.collectInfo}>
              <p>
                {cardData?.identificationPackage && (
                  <>{cardData?.identificationPackage} </>
                )}
                <span className={styles.highlighted}>Peso total:</span>
                {`${String(cardData?.weight)?.replace(".", ",")}kg`}
              </p>

              <p>
                <span className={styles.highlighted}>Envio com seguro:</span>
                {cardData?.insurance ? "Sim" : "Não"}
              </p>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Previsão de entrega:</span>
                {cardData?.previewDate
                  ? momentBDays(cardData?.previewDate).format("DD/MM/YYYY")
                  : momentBDays(addBusinessDaysIgnoreHolidays(
                    cardData?.correios?.desconto > 0
                      ? Number(cardData?.correios?.prazoEntrega) + 2
                      : Number(cardData?.correios?.prazoEntrega),
                    cardData.destination.state
                  ))
                    .format("DD/MM/YYYY")}
              </p>

              <p>
                <span className={styles.highlighted}>Postagem:</span>
                {cardData?.rateType === RateTypeShippingEnum.RETAIL
                  ? "Correios"
                  : "Coleta"}
                {cardData?.identificationPackage && (
                  <>
                    {cardData?.identificationPackage} <br />
                  </>
                )}
              </p>
              <p>
                <span className={styles.highlighted}>Peso total:</span>
                {`${String(cardData?.weight)?.replace(".", ",")}kg`}
              </p>
            </div>
          </div>}
          {/* <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>INFORMAÇÕES ADICIONAIS</h3>
            <div className={styles.collectInfo}>
              <span className={styles.highlighted}>Nota fiscal:</span>
              <span className={styles.handleInvoice}>Gerar nota fiscal</span>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

function cardShippingAreEqual(prevShipping, nextShipping) {
  const shippingHasSameCheckEqual =
    prevShipping.isSelected === nextShipping.isSelected;

  const widthWindowIsEqual =
    prevShipping.widthWindows === nextShipping.widthWindows;

  return shippingHasSameCheckEqual && widthWindowIsEqual;
}
export const CartSimpleCardShippingComponent = React.memo(
  CartSimpleCardShipping,
  cardShippingAreEqual
);
